import React from 'react';
import {Tooltip} from '@/components/tooltips';
import i18n from 'i18n';
import Icon from '@/components/icons/Icon';

interface Props {
    progressPercentage: number
    percThisPeriod: number
    percComparablePeriod: number
    percChange: number
}

export const ProgressBar = React.memo<Props>((
    {
        progressPercentage,
        percThisPeriod,
        percComparablePeriod,
        percChange,
    },
) => {

    const rgbColor = `rgb(
        ${255 * (Math.abs(progressPercentage) / 100)}, 
        ${255 - 255 * (Math.abs(progressPercentage) / 100)},
        0)`

    return (
        <div>
            <span>
                {(0 <= Math.abs(progressPercentage) && Math.abs(progressPercentage) < 25) && (
                    <>
                        <Tooltip
                            content={`${percComparablePeriod.toFixed(2)}% -> ${percThisPeriod.toFixed(2)}% (${percChange.toFixed(2)}%)`}
                            placement="top"
                        >
                            <button
                                type="button"
                                className="btn btn-link p-0 ml-2"
                                style={{cursor: 'pointer', border: 'none', background: 'none'}}
                                data-cy="progress-bar-btn-3">
                                <Icon name='mdi-chevron-down' style={{color: rgbColor}} />
                            </button>
                        </Tooltip>
                        {i18n.t('jt_low.text')}
                    </>
                )}
                {(25 <= Math.abs(progressPercentage) && Math.abs(progressPercentage) < 50) && (
                    <>
                        <Tooltip
                            content={`${percComparablePeriod.toFixed(2)}% -> ${percThisPeriod.toFixed(2)}% (${percChange.toFixed(2)}%)`}
                            placement="top"
                        >
                            <button
                                type="button"
                                className="btn btn-link p-0 ml-2"
                                style={{cursor: 'pointer', border: 'none', background: 'none'}}
                                data-cy="progress-bar-btn-2">
                                <Icon name='mdi-minus' style={{color: rgbColor}} />
                            </button>
                        </Tooltip>
                        {i18n.t('jt_medium.text')}
                    </>
                )}
                {(50 <= Math.abs(progressPercentage) && Math.abs(progressPercentage) < 75) && (
                    <>
                        <Tooltip
                            content={`${percComparablePeriod.toFixed(2)}% -> ${percThisPeriod.toFixed(2)}% (${percChange.toFixed(2)}%)`}
                            placement="top"
                        >
                            <button
                                type="button"
                                className="btn btn-link p-0 ml-2"
                                style={{cursor: 'pointer', border: 'none', background: 'none'}}
                                data-cy="progress-bar-btn-1">
                                <Icon name='mdi-chevron-up' style={{color: rgbColor}} />
                            </button>
                        </Tooltip>
                        {i18n.t('jt_high.text')}
                    </>
                )}
                {(75 <= Math.abs(progressPercentage)) && (
                    <>
                        <Tooltip
                            content={`${percComparablePeriod.toFixed(2)}% -> ${percThisPeriod.toFixed(2)}% (${percChange.toFixed(2)}%)`}
                            placement="top"
                        >
                            <button
                                type="button"
                                className="btn btn-link p-0 ml-2"
                                style={{cursor: 'pointer', border: 'none', background: 'none'}}
                                data-cy="progress-bar-btn">
                                <Icon name='mdi-chevron-double-up' style={{color: rgbColor}} />
                            </button>
                        </Tooltip>
                        {i18n.t('jt_extra_high.text')}
                    </>
                )}
            </span>
            <div className='progress progress-xs margin-vertical-10'>
                <div className={'progress-bar'}
                    style={{
                        width: `${Math.abs(progressPercentage)}%`,
                        height: '6px',
                        filter: 'brightness(1.15)',
                        backgroundColor: rgbColor,
                    }} />
            </div>
        </div>
    );
});

